module.exports = __webpack_public_path__ + "static/img/1_1_6.355d6f62.jpg";